import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { URLS } from '../app-url.constant';
import { CommonService } from './common/common.service';

@Injectable({
  providedIn: 'root',
})
export class UserAccessManagementService {
  constructor(
    private http: HttpClient,
    private commSvc: CommonService
  ) {}

  getCorporateOfficeList() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.CorporateOfficeMaster.endpoint}${URLS.CorporateOfficeMaster.methods.GetCorporateOfficeDropdown}`
    );
  }

  getReginalOfficeList(corporateOfficeId: number) {
    const requestBody = {
      requestUserLoginName: this.commSvc.getReqLoginUserName(),
      requestId: '',
      data: {
        croporateOfficeId: corporateOfficeId,
      },
    };
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.RegionalOfficeMaster.endpoint}${URLS.RegionalOfficeMaster.methods.GetRegionalOfficeDropdown}`,
      requestBody
    );
  }

  getSiteOfficeList(siteOfficeId: number) {
    const requestBody = {
      requestUserLoginName: this.commSvc.getReqLoginUserName(),
      requestId: '',
      data: {
        regionalOfficeId: siteOfficeId,
      },
    };
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.SiteOfficeMaster.endpoint}${URLS.SiteOfficeMaster.methods.GetSiteOfficeForDropdown}`,
      requestBody
    );
  }

  getSiteOfficeForDropdownByRegionalOfficeAccessIds(regionalOfficeIds: any) {
    const requestBody = {
      requestUserLoginName: this.commSvc.getReqLoginUserName(),
      requestId: '',
      data: {
        regionalOfficeAccessIds: regionalOfficeIds,
      },
    };

    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.SiteOfficeMaster.endpoint}${URLS.SiteOfficeMaster.methods.GetSiteOfficeForDropdownByRegionalOfficeAccessIds}`,
      requestBody
    );
  }

  getUsersAccessManagementList() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.UserAccessManagement.endpoint}${URLS.UserAccessManagement.methods.GetUserAccessManagementList}`
    );
  }

  getModuleList() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetAllModuleMaster}`
    );
  }

  getSubModuleList() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetAllSubModuleMaster}`
    );
  }

  getModuleSubModuleList() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetAllModuleSubModuleMaster}`
    );
  }

  getUserModuleAccessList(id: any) {
    let param = {
      Id: id,
    };
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.UserAccessManagement.endpoint}${URLS.UserAccessManagement.methods.AddUserAccessModuleById}`,
      { params: param }
    );
  }

  addUserAccessModule(requestBody: any, userId: any, type: any) {
    let param = {
      Id: userId,
      type: type,
    };
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.UserAccessManagement.endpoint}${URLS.UserAccessManagement.methods.AddUserAccessModule}`,
      requestBody,
      { params: param }
    );
  }

  getUserAccessModules() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.UserAccessManagement.endpoint}${URLS.UserAccessManagement.methods.GetUserAccessModuleDetailsByUserId}`
    );
  }
}
